/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.controllers.module.ts" />
/// <reference path="../../common/iapirequestconfig.ts" />
/// <reference path="../../common/services/apiservice.ts" />
/// <reference path="../../common/controllers/screencontrollerbase.ts" />
/// <reference path="../../common/services/usermessagesservice.ts" />
/// <reference path="../services/enumhelperservice.ts" />

module App.Common.Controllers {
	'use strict';

	class TestPerson {
		constructor(
			public firstName: string,
			public lastName: string,
			public age: number,
			public jobTitle: string,
			public progress: number) {}

		public name = () => `${this.firstName} ${this.lastName}`;
		public nameReverse = () => `${this.lastName}, ${this.firstName}`;
	}

	class UserInterfaceTestsController extends Controllers.ScreenControllerBase {

		public static $inject = ['$injector', 'app.common.services.enumHelperService'];

		constructor($injector: angular.auto.IInjectorService, private enumHelper: Common.Services.EnumHelperService) {
			super($injector);

			this.title = 'User Interface Tests';
		}

		public initialize(): angular.IPromise<any> {
			return this.$q.resolve(true);
		}

		public errorTest(errorType: string) {
			this.busyPromise = this.api.get({
				resourceName: 'ErrorTests',
				params: { id: errorType }
			});
		}

		public badHostname() {
			this.busyPromise = this.api.get({
				url: 'http://nonexistentdomain.gov.uk/api/BadData'
			});
		}

		public throwRuntimeException(): string {
			const x: any = {};
			return x.foo.bar;
		}

		public badWebApiRoute(): void {
			this.busyPromise = this.api.get({
				resourceName: 'BadController'
			});
		}

		public userMessage(message: string, type: string, defer: boolean = false): void {
			this.userMessages.addMessage(`${message} created at ${this
				.$filter('date')(new Date(), this.globalSettings.preciseDateTimeFormat)}`,
				this.enumHelper.getValue(UserMessageType, type),
				defer);
		}

		public clearUserMessages() {
			this.userMessages.clear();
		}

		public collectDeferredUserMessages() {
			this.userMessages.collectDeferredMessages();
		}

		public testTableData: TestPerson[] = [
			new TestPerson('Joe', 'Bloggs', 23, 'Farmer', 40),
			new TestPerson('Fred', 'Smith', 9, 'Student', 89),
			new TestPerson('Alice', 'Evans', 32, 'Plumber', 21)
		];

	}

	angular
		.module('app.common.controllers')
		.controller('app.common.controllers.userInterfaceTestsController', UserInterfaceTestsController);
}